module.exports = __webpack_public_path__ + "static/media/russian_flag.00aa0e42.jpg";